import React from 'react'

import useAuth from '../hooks/useAuth'
import PlateLoader from '../components/PlateLoader'

const PlatePage: React.FC = () => {
  const loadingState = useAuth()

  return (
    <div className="App">
      <PlateLoader loadingState={loadingState} />
    </div>
  )
}

export default PlatePage
